module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "clustering-gql.worker.79c25987778cf0254017.worker.js");
}
